import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const HeaderAdv1 = () => {
  return <header className="bg-white" data-id="element-6144">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-6145"></div>
      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-6146">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-6147">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-6148">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-6149">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>
        <div className="flex justify-start mb-3" data-id="element-6150">
          <div className="text-xs text-gray-400 font-sans" data-id="element-6151">Advertorial 1</div>
        </div>
        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-6152">
          <div className="text-left" data-id="element-6153">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-6154">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-6155">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>
      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-6156">
        <div className="max-w-4xl mx-auto" data-id="element-6157">
          <div className="flex items-center text-xs text-gray-500 mb-4 border-b border-gray-200 pb-2" data-id="element-6158">
            <div className="flex items-center mr-4" data-id="element-6159">
              <BookOpenIcon className="h-3 w-3 mr-1" data-id="element-6160" />
              <span data-id="element-6161">Health Investigation Series</span>
            </div>
            <div className="flex items-center" data-id="element-6162">
              <CalendarIcon className="h-3 w-3 mr-1" data-id="element-6163" />
              <span data-id="element-6164">
                Updated:{' '}
                {(() => {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return yesterday.toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                });
              })()}
              </span>
            </div>
          </div>
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-6165">
            INVESTIGATIVE REPORT
          </div>
          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-6166">
            73-Year-Old Corning Engineer Exposes Why All Grounding Sheets Fail —
            Then Builds Ones That Don't
          </h1>
          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-6167">
            How submarine cable technology and $388,716 in retirement savings
            led to the only grounding sheets that still work after 1,000 washes
          </p>
          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-6168">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-6169">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fGXq9Q6heUEMtiucmQrs1x/Tom-Davidson.jpg" alt="Tom Davidson" className="w-full h-full object-cover" data-id="element-6170" />
            </div>
            <div className="flex-1" data-id="element-6171">
              <div className="flex items-center" data-id="element-6172">
                <div className="font-medium text-gray-900 text-lg" data-id="element-6173">
                  By Tom Davidson
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-6174">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-6175" />
                  <span className="text-xs ml-1 font-medium" data-id="element-6176">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-6177">
                Retired Electrical Engineer, Corning Inc. | As told to
                Traditional Medicine Publications
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-6178">
                <div className="flex items-center mr-4" data-id="element-6179">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-6180" />
                  <span data-id="element-6181">9 min read</span>
                </div>
                <div className="flex items-center" data-id="element-6182">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-6183" />
                  <span data-id="element-6184">18,342 views</span>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5" data-id="element-6185">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/232sjW71qLLR3zci5F48Jb/1_Tom_Davidson.png" alt="Tom Davidson working at his desk with engineering equipment" className="w-full rounded-lg shadow-md" data-id="element-6186" />
          </div>
          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-6187">
            <div className="mb-1 flex items-center" data-id="element-6188">
              <span className="font-medium mr-2" data-id="element-6189">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-6190">
              <span className="font-medium mr-2" data-id="element-6191">Published:</span>
              November 2025
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderAdv1;